import { extendTheme, withDefaultColorScheme } from '@lego/klik-ui';
import { ButtonComponentStyle } from './button-theme';
import { ModalComponentStyle } from './modal-theme';

// Legacy Klik theme. Do not add to this file.
// Remove it when Klik is removed
const colorScheme = 'dark-blue';

const defaultColorScheme = withDefaultColorScheme({ colorScheme });

export const theme = extendTheme(defaultColorScheme, {
  components: {
    Button: ButtonComponentStyle,
    Modal: ModalComponentStyle,
  },
  fonts: { body: 'LEGO Typewell', heading: 'LEGO Typewell' },
});
